var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ pcStyle: _vm.isPc, mobileStyle: _vm.isMobile },attrs:{"id":"my-toast-box"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-toast-content"},[_c('div',{attrs:{"id":"my-toast-title"}})])
}]

export { render, staticRenderFns }